import React from 'react';
import { Link } from 'gatsby';
import useSiteMetaData from '../hooks/use-site-metadata';
import Logo from '../icons/logo-gradient2.svg';
import Facebook from '../icons/facebook.svg';
import Twitter from '../icons/twitter.svg';
import Linkedin from '../icons/linkedin.svg';
import Instagram from '../icons/instagram.svg';
import Container from './Container';
import style from '../cssmodules/footer.module.scss';

function Footer() {
  const { facebook, twitter, linkedIn, instagram } = useSiteMetaData();
  const year = new Date().getFullYear();
  return (
    <Container>
      <div className={style.footer}>
        <div className={style.column}>
          <h3 className={style.heading}>Email</h3>
          <a className={`${style.email}`} href="mailto:info@opyl.ai">
            info@opyl.ai
          </a>
          <div className={`${style.address} ${style.addressDesktop}`}>
            <h3 className={style.heading}>Address</h3>
            <p>
              Engine House, 105 Wellington Street
              <br />
              St Kilda, Victoria 3191, Australia
            </p>
          </div>
          <h3 className={style.heading}>Follow Us</h3>
          <ul className={style.social}>
            <li>
              <a href={facebook} target="_blank" rel="noopener noreferrer">
                <Facebook />
              </a>
            </li>
            <li>
              <a href={twitter} target="_blank" rel="noopener noreferrer">
                <Twitter />
              </a>
            </li>
            <li>
              <a href={linkedIn} target="_blank" rel="noopener noreferrer">
                <Linkedin />
              </a>
            </li>
            <li>
              <a href={instagram} target="_blank" rel="noopener noreferrer">
                <Instagram />
              </a>
            </li>
          </ul>
        </div>
        <div className={`${style.column} ${style.columnBrand}`}>
          <div className={style.logo}>
            <Logo />
          </div>
          <div className={`${style.address} ${style.addressMobile}`}>
            <p>
              Engine House, 105 Wellington Street
              <br />
              St Kilda, Victoria 3191, Australia
            </p>
          </div>
          <p className={style.strapline}>
            Real world health informatics and predictive analytics
          </p>
        </div>
        <div className={style.column}>
          <ul className={style.nav}>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/technologies">Technologies</Link>
            </li>
            <li>
              <Link to="/investor">Investor</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
          <p className={style.credits}>
            <span>Copryright &copy; {year} Opyl Ltd</span>
            <span>
              <a href="https://maltcreative.com.au">Website brewed by Malt</a>
            </span>
          </p>
        </div>
      </div>
    </Container>
  );
}

export default Footer;
